import React, { useState } from 'react';
import './alert.scss';
import { Icon } from '@ampol/design-system';

/**
 * Alert information that is dismissible
 * @param children Child | child[] component(s) child to be rendered inside this modal
 * @param onClose Close model event
 * @param type Type of alert ('info': DEFAULT | 'warning' | 'error')
 * @param align Align content ('centre': DEFAULT | 'left')
 * @param dismissible Enable close/dismiss the alert
 * @returns JSX Element
 */
const Alert = ({ type = 'info', align = 'centre', dismissible, onClose, ...props }) => {
  const [isClosed, setIsClosed] = useState(false);

  const closeAlert = () => {
    setIsClosed(true);
    onClose && onClose();
  };

  return <>
    {!isClosed && <div className={`alert alert--${type}`}>
      <div className={`alert__body alert__body--${align}`}>
        {props.children}
      </div>
      {dismissible && <button
        className='alert__close'
        type={'button'}
        onClick={closeAlert}
        aria-label={'Close message'}>
        <Icon url={'/icons/close.svg'} />
      </button>}
    </div>}
  </>;
};

export default Alert;
